<template>
  <div
    id="base"
    class="bg-white px-3"
    style="margin: -20px; margin-top: -1rem; margin-bottom: 0 !important"
  >
    <el-tabs v-model="type" @tab-click="handleClick">
      <el-tab-pane
        v-for="(item, index) in $store.state.user.userchannel"
        :key="index"
        :label="item.channel_name"
        :name="item.channel.toString()"
      >
        <el-form
          ref="form"
          :model="form_1"
          v-if="type == item.channel"
          label-width="300px"
        >
          <div v-for="(items, indexs) in list" :key="indexs">
            <el-divider>{{ key_name[indexs] }}</el-divider>
            <el-form-item
              v-for="(item, index) in items"
              :label="item.name"
              :key="index"
            >
              <el-input
                placeholder=""
                v-if="item.other_type == 0"
                class="w-50"
                v-model="item.value_set"
              >
              </el-input>

              <el-input
                placeholder=""
                v-if="item.other_type == 2"
                type="textarea"
                class="w-50"
                v-model="item.value_set"
                :rows="4"
              >
              </el-input>
              <!-- 时间选择 -->
              <el-date-picker
                v-model="item.value_set"
                v-if="item.other_type == 3"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                align="right"
                type="date"  
                placeholder="选择日期"
              >
              </el-date-picker>

              <el-switch
                v-if="item.other_type == 1"
                v-model="item.value_set"
                active-value="1"
                inactive-value="0"
                active-color="#13ce66"
              >
              </el-switch>
            </el-form-item>
          </div>
          <el-form-item>
            <el-button v-auth="'addSystem'" @click="addOrEdit" type="primary"
              >保存</el-button
            >
          </el-form-item>
        </el-form>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import common from "@/common/mixins/common.js";
import tinymce from "@/components/common/tinymce.vue";
export default {
  components: {
    tinymce,
  },
  inject: ["layout"],
  mixins: [common],
  data() {
    return {
      type: "4",
      xyIndex: 0,
      form_1: {},
      preUrl: "user/systemList", //列表地址
      addUrl: "user/addSystem", //修改地址
      tableData: [],
      checkboxGroup1: [],
      list: {}, // 数据
      key_name: {}, // 标题
      content: "",
    };
  },
  methods: {
    getListResult(e) {
      if (this.type == 700) {
        this.list = e.list.map((item) => {
          item.value_set = item.value_set == 1 ? true : false;
          return item;
        });

        this.list = e.list;
      } else {
        this.list = e.list;
      }
      this.key_name = e.key_name;
      console.log(e);
    },
    handleClick(tab, event) {
      this.list = [];
      this.search = "";
      this.getList();
    },

    addOrEdit() {
      console.log(this.list);
      this.layout.loading = true;
      this.api
        .post(this.addOrEditUrl(), { data: this.list })
        .then((res) => {
          let all = res.data;
          if (all.code == 1) {
            this.$message({
              message: "修改成功",
              type: "success",
            });
          }
          this.layout.loading = false;
        })
        .catch((err) => {
          this.layout.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.el-divider--horizontal {
  margin: 40px 0 !important;
}
</style>
